/**
 * PURE membership statistics (F3): breakdown by status, baptized,
 * serving and leadership — over the synced memberships (`people`).
 */

export interface MembershipLike {
  id: string;
  church_id?: string | null;
  status: string | null;
  baptized: number | boolean | null;
  serves: number | boolean | null;
  is_leader: number | boolean | null;
  is_pastor: number | boolean | null;
  deleted_at?: string | null;
}

export interface MembershipBreakdown {
  total: number;
  byStatus: { status: string; count: number }[];
  baptized: number;
  serving: number;
  leaders: number;
  pastors: number;
}

function truthy(v: number | boolean | null | undefined): boolean {
  return v === true || v === 1;
}

export function membershipBreakdown(
  memberships: readonly MembershipLike[],
  churchId?: string | null,
): MembershipBreakdown {
  const rows = memberships.filter((m) => !m.deleted_at && (!churchId || m.church_id === churchId));
  const byStatus = new Map<string, number>();
  let baptized = 0;
  let serving = 0;
  let leaders = 0;
  let pastors = 0;
  for (const m of rows) {
    const status = m.status?.trim() || "unknown";
    byStatus.set(status, (byStatus.get(status) ?? 0) + 1);
    if (truthy(m.baptized)) {
      baptized += 1;
    }
    if (truthy(m.serves)) {
      serving += 1;
    }
    if (truthy(m.is_leader)) {
      leaders += 1;
    }
    if (truthy(m.is_pastor)) {
      pastors += 1;
    }
  }
  return {
    total: rows.length,
    byStatus: [...byStatus.entries()]
      .toSorted(([, a], [, b]) => b - a)
      .map(([status, count]) => ({ status, count })),
    baptized,
    serving,
    leaders,
    pastors,
  };
}
